import {isSameDate, clone} from '../../../../utils/helper'

const getServicesSelectedCounter = function (state) {
  return state.services.selected.length
}

const getServicesCounter = function (state) {
  return state.services.list.length
}

const getTrasferimentiCounter = function (state) {
  return state.trasferimenti.list.length
}

const getListaServizi = function (state) {
  return state.services.list.filter(item => item.anagrafica != null)
}

const getListaTrasferimenti = function (state) {
  return state.trasferimenti.list
}

const getTrasferimentoByProductId = (state) => (productID) => {
  const item = state.trasferimenti.list.find(item => item.detail.productID.trim() === productID.trim())
  // NB° estremamente importante clonare l'oggetto trasferimento in particolare i gruppi
  return item ? clone(item) : item
}

const getServiziSelected = function (state) {
  return state.services.selected
}

const getTrasferimentiSelected = function (state) {
  let list = []
  const {andata, ritorno} = state.trasferimenti
  if (andata) list.push(andata)
  if (ritorno) list.push(ritorno)
  return list
}

const getServiziSelectedByDay = (state) => (day) => {
  return state.services.selected.filter(item => {
    return item.groups.some(group => isSameDate(group.dateSelected, day))
  })
}

const getTrasferimentiSelectedByDay = (state) => (day) => {
  const list = getTrasferimentiSelected(state)
  return list.filter(item => {
    return item.groups.some(group => isSameDate(group.dateSelected, day))
  })
}

const serviceSelectedCounter = (state) => {
  return state.services.selected.length
}

const trasferimentiSelectedCounter = (state) => {
  return getTrasferimentiSelected(state).length
}

const getServiziFilter = function (state) {
  return {...state.services.filter}
}

const getServiziOrder = function (state) {
  return {...state.services.order}
}

const getTrasferimentiFilter = function (state) {
  return {...state.trasferimenti.filter}
}

const getTrasferimentiOrder = function (state) {
  return {...state.trasferimenti.order}
}

export default {
  getServicesSelectedCounter,
  getServicesCounter,
  getListaServizi,
  getServiziSelected,
  getServiziSelectedByDay,
  getListaTrasferimenti,
  getTrasferimentoByProductId,
  getTrasferimentiSelected,
  getTrasferimentiSelectedByDay,
  serviceSelectedCounter,
  trasferimentiSelectedCounter,
  getServiziFilter,
  getTrasferimentiFilter,
  getServiziOrder,
  getTrasferimentiOrder,
  getTrasferimentiCounter
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/service.js